// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
export function useMiniAppNavigation(u) {
  const initial = typeof u === "string" ? { tab: u } : u;
  const [o, m] = React.useState(initial.tab),
    [r, g] = React.useState(initial.walletOpen ?? false),
    [j, B] = React.useState(initial.casesOpen ?? false),
    [U, N] = React.useState(initial.homeView ?? "main");
  return {
    tab: o,
    walletOpen: r,
    casesOpen: j,
    homeView: U,
    setWalletOpen: g,
    setCasesOpen: B,
    setHomeView: N,
    openTab: X => {
      m(X), g(!1), B(!1), N("main"), window.scrollTo(0, 0);
    }
  };
}
